const USER_TYPE_COOKIE_KEY = 'umespaco_user_type';
const ONE_DAY_SECONDS = 24 * 60 * 60;

const getSecureFlag = () => {
  if (typeof window === 'undefined') return '';
  return window.location.protocol === 'https:' ? '; Secure' : '';
};

export const setUserTypeCookie = (userType?: string | null) => {
  if (typeof document === 'undefined') return;

  if (!userType) {
    clearUserTypeCookie();
    return;
  }

  const value = encodeURIComponent(userType);
  document.cookie = `${USER_TYPE_COOKIE_KEY}=${value}; Max-Age=${ONE_DAY_SECONDS}; Path=/; SameSite=Lax${getSecureFlag()}`;
};

export const getUserTypeCookie = (): string | null => {
  if (typeof document === 'undefined') return null;

  const cookies = document.cookie ? document.cookie.split('; ') : [];
  const target = cookies.find((cookie) => cookie.startsWith(`${USER_TYPE_COOKIE_KEY}=`));

  if (!target) return null;

  const value = target.substring(`${USER_TYPE_COOKIE_KEY}=`.length);
  return value ? decodeURIComponent(value) : null;
};

export const clearUserTypeCookie = () => {
  if (typeof document === 'undefined') return;
  document.cookie = `${USER_TYPE_COOKIE_KEY}=; Max-Age=0; Path=/; SameSite=Lax${getSecureFlag()}`;
};
